import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { IconSize } from '@freelancer/ui/icon';
import { LinkColor, LinkUnderline, QueryParams } from '@freelancer/ui/link';
import { ListItemPadding, ListItemType } from '@freelancer/ui/list-item';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'fl-split-button-option',
  template: `
    <fl-text
      *ngIf="!link"
      [size]="fontSize"
      [sizeTablet]="fontSizeTablet"
      [sizeDesktop]="fontSizeDesktop"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </fl-text>

    <fl-link
      *ngIf="link"
      [color]="LinkColor.FOREGROUND"
      [link]="link"
      [newTab]="newTab"
      [queryParams]="linkQueryParams"
      [size]="fontSize"
      [sizeTablet]="fontSizeTablet"
      [sizeDesktop]="fontSizeDesktop"
      [underline]="LinkUnderline.NEVER"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </fl-link>
    <ng-template #content>
      <fl-list-item
        [clickable]="true"
        [bordered]="false"
        [padding]="optionPadding"
      >
        <div class="OptionListItem">
          <fl-icon
            *ngIf="iconName"
            [name]="iconName"
            [size]="iconSize"
            [flMarginRight]="'xxsmall'"
          ></fl-icon>
          {{ displayText }}
        </div>
      </fl-list-item>
    </ng-template>
  `,
  styleUrls: ['./split-button-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplitButtonOptionComponent {
  LinkColor = LinkColor;
  LinkUnderline = LinkUnderline;
  ListItemType = ListItemType;

  @Input() fontSize = TextSize.XSMALL;
  @Input() fontSizeTablet?: TextSize;
  @Input() fontSizeDesktop?: TextSize;
  @Input() iconSize = IconSize.MID;
  @Input() optionPadding = ListItemPadding.XSMALL;
  @Input() link?: string;
  @Input() linkQueryParams?: QueryParams;
  @Input() newTab?: boolean = false;
  @Input() iconName?: string;
  @Input() displayText: string;

  @HostBinding('attr.role') ariaRole = 'listitem';

  constructor(public changeDetectorRef: ChangeDetectorRef) {}
}
